/**
 * Trustpilot widget: updates the rating and review count from the Supabase score API.
 * The static review card is now rendered in Liquid, without JS.
 */

const SUPABASE_HEADERS = {
  Authorization:
    'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZG9teHpicnV4ZWRjY2RkeW5hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MjcxMzEsImV4cCI6MjA2OTMwMzEzMX0.6sMWnC7DOZ_e7jrmF1KVTSIreCz5JkCmYEP12RRRK-w',
  apikey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhqZG9teHpicnV4ZWRjY2RkeW5hIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3MjcxMzEsImV4cCI6MjA2OTMwMzEzMX0.6sMWnC7DOZ_e7jrmF1KVTSIreCz5JkCmYEP12RRRK-w',
};

function escapeHtml(text) {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

/** Inline SVG path for the Trustpilot star shape */
const STAR_PATH =
  'M9.88 6.225H16l-4.929 3.504-3.047 2.149-4.953 3.504L4.952 9.73 0 6.225h6.119L8 .572l1.881 5.653Zm1.596 4.812L8 11.9l4.929 3.527-1.453-4.392Z';

// Square icon with a white star on a green tile (for the star row under the logo)
function starSvg(fillType) {
  const extraClass = fillType === 'empty' ? ' trustpilot-star-svg--empty' : '';
  return `
    <svg aria-hidden="true" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" width="20" height="20" class="trustpilot-star-svg${extraClass}">
      <rect x="0" y="0" width="16" height="16" fill="#00b67a"></rect>
      <g transform="translate(2 2) scale(0.75)">
        <path fill-rule="evenodd" clip-rule="evenodd" fill="#ffffff" d="${STAR_PATH}"></path>
      </g>
    </svg>
  `;
}

/**
 * Build 5 stars HTML using inline SVG. Supports decimal rating (e.g. 4.9).
 * @param {number} rating - 0..5, can be decimal
 * @param {string} className - optional class for the stars container
 */
function buildStarsHtml(rating, className) {
  const fullCount = Math.ceil(rating);
  const partial = rating % 1;
  const hasPartial = partial > 0.01;
  const emptyCount = 5 - fullCount - (hasPartial ? 1 : 0);
  const parts = [];
  for (let i = 0; i < fullCount; i++) parts.push(starSvg('full'));
  // if (hasPartial) {
  //   parts.push(
  //     `<span class="trustpilot-star trustpilot-star--partial" style="--fill: ${partial}">${starSvg('full')}</span>`
  //   );
  // }
  for (let i = 0; i < emptyCount; i++) parts.push(starSvg('empty'));
  const wrap = className ? ` class="${escapeHtml(className)}"` : '';
  return `<span class="trustpilot-stars"${wrap}>${parts.join('')}</span>`;
}

async function fetchScore(apiUrl) {
  const res = await fetch(apiUrl, { headers: SUPABASE_HEADERS });
  if (!res.ok) throw new Error(res.status);
  const data = await res.json();
  if (data && data.length > 0) return data[0];
  return null;
}

function initWidget(section) {
  const widgetEl = section.querySelector('.trustpilot');
  if (!widgetEl) return;

  const starsContainer = widgetEl.querySelector('.trustpilot-widget__stars');
  const scoreValueEl = widgetEl.querySelector('.trustpilot-widget__score-value');
  const scoreCountEl = widgetEl.querySelector('.trustpilot-widget__score-count');

  // Official TrustBox widget has none of these elements — nothing to update.
  if (!starsContainer && !scoreValueEl && !scoreCountEl) return;

  const ratingUrl = section.dataset.ratingUrl || '';

  function updateScoreData(stars, count) {
    const safeStars = Number.isFinite(stars) && stars > 0 ? stars.toFixed(1) : '—';
    const safeCount = Number.isFinite(count) && count > 0 ? `${count} reviews` : '—';
    if (starsContainer) starsContainer.innerHTML = buildStarsHtml(stars || 0);
    if (scoreValueEl) scoreValueEl.textContent = safeStars;
    if (scoreCountEl) scoreCountEl.textContent = safeCount;
  }

  updateScoreData(5, 0);

  fetchScore(ratingUrl)
    .then((scoreData) => {
      const stars = scoreData ? Number(scoreData.trustScore) || 0 : 0;
      const count = scoreData ? Number(scoreData.numberOfReviews) || 0 : 0;
      updateScoreData(stars, count);
    })
    .catch(() => {
      updateScoreData(5, 0);
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.trustpilot-review-card-section').forEach((section) => {
      initWidget(section);
    });
  });
} else {
  document.querySelectorAll('.trustpilot-review-card-section').forEach((section) => {
    initWidget(section);
  });
}
